var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page_header"},[_c('router-link',{attrs:{"to":{ name: 'top-page' }}},[_c('h1',[_vm._v("File Passport")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }